import UserRead from '@/objects/users/UserRead';
import Vue from 'vue';
import gql from 'graphql-tag';
import graphql from '@/helpers/graphql';
import AccessDeniedError from '@/objects/errors/accessDenied';
import UserFetchState from '@/objects/users/UserFetchState';
import router from '../router';

export interface SelfState {
  user?: UserRead;
}

const state: SelfState = { user: undefined };

const actions = {
  // eslint-disable-next-line
  async logOff({ commit }: any, savePage: boolean = false): Promise<boolean> {
    commit('logOff', savePage);
    return true;
  },

  // eslint-disable-next-line
  async getSelf({ commit }: any, savePage: boolean = false): Promise<UserFetchState> {
    try {
      const query = gql`
      query {
        self {
          id
          name
          email
          active
          role {
            id
            type
            value
          }
          permissions
        }
      }`;

      const response = await graphql(query, null, false, true);
      if (response && response.self) {
        commit('saveSelf', response.self);
        return UserFetchState.GOOD;
      }

      return UserFetchState.BAD;
    } catch (err) {
      if (err instanceof AccessDeniedError) {
        commit('logOff', savePage);
        return UserFetchState.BAD;
      }

      console.error(err);
      return UserFetchState.INTERNET_DOWN;
    }
  },
};

const mutations = {
  saveSelf(newState: SelfState, newUser: UserRead) {
    newState.user = newUser;
  },
  logOff(newState: SelfState, savePage: boolean) {
    Vue.$cookies.set(
      'session_id',
      '',
      new Date(),
      '/',
      window.location.href.includes('localhost') ? 'localhost' : '.degreenexus.com',
    );
    newState.user = undefined;

    if (savePage) {
      router.push({ path: '/public/login', query: { refer: router.currentRoute.path } });
    }
  },
};

const getters = {

};

export const self = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
